import React from 'react'
import PropTypes from 'prop-types'
import { axisBottom, axisLeft, axisRight, axisTop } from 'd3'
import { useD3Selection } from 'hooks'
import styles from 'Axis.scss'

const axisMap = {
  top: axisTop,
  bottom: axisBottom,
  left: axisLeft,
  right: axisRight,
}

function Axis({
  transform,
  direction,
  scale,
  ticks = 10,
  tickSizeInner = 6,
  tickSizeOuter = 6,
  format = null,
  height = 0,
  unit,
  ...props
}) {
  const [ref, useSelectionEffect] = useD3Selection()

  // create D3 axis generator
  const axis = React.useMemo(
    () =>
      (axisMap[direction] || axisBottom)()
        .ticks(ticks)
        .tickFormat(format)
        .tickSizeInner(tickSizeInner)
        .tickSizeOuter(tickSizeOuter),
    [direction, ticks, tickSizeInner, tickSizeOuter, format]
  )

  // redraw with transition when scale changes
  useSelectionEffect(
    selection => {
      axis.scale(scale)(selection)
    },
    [scale, axis]
  )

  return (
    <g transform={transform} {...props}>
      <g ref={ref} />
      {unit && (
        <text className={styles.unit} transform={`translate(0, ${height + 10})`}>
          {unit}
        </text>
      )}
    </g>
  )
}

Axis.propTypes = {
  data: PropTypes.array,
  unit: PropTypes.string,
  scale: PropTypes.func,
  format: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transform: PropTypes.string,
  direction: PropTypes.string,
  ticks: PropTypes.number,
  tickSizeInner: PropTypes.number,
  tickSizeOuter: PropTypes.number,
  height: PropTypes.number,
}

export default React.memo(Axis)
